module.exports = __webpack_public_path__ + "img/IMG_5892.6c23990f.jpg";